import AuthStore from 'stores/AuthStore';
import {featureFlags} from 'utils/const';
import User from 'records/User';

export default function hasFlag(flag: featureFlags, user?: User) {
  user = user ?? AuthStore.getState().user;
  if (!user?.flags) {
    return false;
  }

  const flags = AuthStore.getState().user.flags;
  return flags.includes(flag);
}

export function hasAnyFlag(flags: featureFlags[]) {
  return flags.some(f => hasFlag(f));
}
